import React, { createContext, useContext, useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { UserBasicInfo } from "../services/ApiUniformSurvey";

interface UserProfileContextType {
  profile: any;
  loading: boolean;
}

const UserProfileContext = createContext<UserProfileContextType>({ profile: null, loading: true });

export const UserProfileProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [profile, setProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const { accounts } = useMsal();

  useEffect(() => {
    // ใช้ email จาก MSAL accounts แทนที่จะใช้จาก sessionStorage เพื่อป้องกันการ tampering
    const secureUserEmail = accounts && accounts.length > 0 ? accounts[0].username : null;
    
    if (!secureUserEmail) {
      setLoading(false);
      return;
    }
    
    const cached = sessionStorage.getItem("userProfile");
    if (cached && cached !== "undefined") {
      try {
        const cachedProfile = JSON.parse(cached);
        // ตรวจสอบว่า cached profile ตรงกับ email ปัจจุบันหรือไม่
        if (cachedProfile && cachedProfile.email === secureUserEmail) {
          setProfile(cachedProfile);
          setLoading(false);
          return;
        } else {
          sessionStorage.removeItem("userProfile");
        }
      } catch (e) {
        // ถ้า parse ไม่ได้ ให้ลบค่าออกจาก sessionStorage
        sessionStorage.removeItem("userProfile");
      }
    }
    
    // ตรวจสอบว่ามี access token หรือไม่ก่อนเรียก API
    const accessToken = sessionStorage.getItem("AccessToken");
    if (!accessToken) {
      setLoading(false);
      return;
    }
    
    // ดึงข้อมูล profile ใหม่
    UserBasicInfo(secureUserEmail)
      .then(res => {
        setProfile(res);
        sessionStorage.setItem("userProfile", JSON.stringify(res));
      })
      .catch(error => {
        // ถ้าเป็น authentication error ไม่ต้องทำอะไรเพิ่ม เพราะ auth flow จะจัดการให้
        setProfile(null);
      })
      .finally(() => setLoading(false));
  }, [accounts]);

  return (
    <UserProfileContext.Provider value={{ profile, loading }}>
      {children}
    </UserProfileContext.Provider>
  );
};

export const useUserProfile = () => useContext(UserProfileContext);
